import { createHttpClient } from "@/services/baseClient";
import { createAdminWatchApi } from "@/services/api/adminWatch";
import { createAuthApi } from "@/services/api/auth";
import { createVehiclesApi } from "@/services/api/vehicles";
import { createTracksApi } from "@/services/api/tracks";
import { createSessionsApi } from "@/services/api/sessions";
import { createEventsApi } from "@/services/api/events";
import { createUploadsApi } from "@/services/api/uploads";
import { createTelemetryApi } from "@/services/api/telemetry";
import { createDevicesApi } from "@/services/api/devices";
import { createTeamsApi } from "@/services/api/teams";
import { createUsersApi } from "@/services/api/users";
import { createApiKeysApi } from "@/services/api/apiKeys";
import { createTrackcastApi } from "@/services/api/trackcast";
import { createMyLiveStreamsApi } from "@/services/api/myLiveStreams";
import { createLapComparisonApi } from "@/services/api/lapComparison";

const httpClient = createHttpClient();

export const apiClient = {
  ...createAdminWatchApi(httpClient),
  ...createAuthApi(httpClient),
  ...createVehiclesApi(httpClient),
  ...createTracksApi(httpClient),
  ...createSessionsApi(httpClient),
  ...createEventsApi(httpClient),
  ...createUploadsApi(httpClient),
  ...createTelemetryApi(httpClient),
  ...createDevicesApi(httpClient),
  ...createTeamsApi(httpClient),
  ...createUsersApi(httpClient),
  ...createApiKeysApi(httpClient),
  ...createTrackcastApi(httpClient),
  ...createMyLiveStreamsApi(httpClient),
  ...createLapComparisonApi(httpClient),
  client: httpClient.client,
  refreshToken: httpClient.refreshToken,
};
